export const prerenderGateCheck = () => {
	return window.__PRERENDER_INJECTED || window.lt.author;
};
